/* globals jQuery, google */

import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';

jQueryBridget('isotope', Isotope, $);

jQuery(window).on('load', function() {
    var $container = jQuery('.project-list');
    $container.isotope({
        filter: '*',
        percentPosition: true,
        layoutMode: 'fitRows',
        animationOptions: {
            duration: 750,
            easing: 'linear',
            queue: false,
        },
    });

    jQuery('.filter [data-filter]').click(function() {
        jQuery('.wrapper-filter.black').removeClass('black');
        jQuery('.filter .current').removeClass('active');
        jQuery(this).addClass('active');

        let selector = jQuery(this).attr('data-filter');
        $container.isotope({
            filter: selector,
            layoutMode: 'fitRows',
            animationOptions: {
                duration: 750,
                easing: 'linear',
                queue: false,
            },
        });
    });

    jQuery(document).ready(function() {
        jQuery('.slick').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            fade: true,
        });

        document.querySelectorAll('.slick-main').forEach(el => {
            let options = {
                autoplay: true,
                autoplaySpeed: 3000,
                fade: true,
            };

            let nav = el.parentNode.querySelector('.slick-nav');
            if (nav) {
                let navOptions = Object.assign({
                    autoplay: false,
                    slidesToShow: 5,
                    arrows: false,
                    centerMode: false,
                    focusOnSelect: true,
                }, options);

                navOptions.asNavFor = el;
                navOptions.fade = false;
                options.asNavFor = nav;
                options.autoplay = false;

                jQuery(nav).slick(navOptions);
            }

            jQuery(el).slick(options);
        });
    });
});

// eslint-disable-next-line
window.initMap = function() {
    var map = new google.maps.Map(document.getElementById('map'), {
        center: {
            lat: 47.40680611727381, lng: 9.32644074999996,
        },
        zoom: 16,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER,
        },

        styles: [
            {
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#F5F5F5',
                    },
                ],
            },
            {
                'elementType': 'labels.icon',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#616161',
                    },
                ],
            },
            {
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {
                        'color': '#F5F5F5',
                    },
                ],
            },
            {
                'featureType': 'administrative',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#FFFFFF',
                    },
                ],
            },
            {
                'featureType': 'administrative',
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {
                        'color': '#000000',
                    },
                    {
                        'weight': 3.5,
                    },
                ],
            },
            {
                'featureType': 'administrative.country',
                'elementType': 'geometry.stroke',
                'stylers': [
                    {
                        'color': '#000000',
                    },
                ],
            },
            {
                'featureType': 'administrative.country',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#FFFFFF',
                    },
                ],
            },
            {
                'featureType': 'administrative.country',
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {
                        'color': '#000000',
                    },
                ],
            },
            {
                'featureType': 'administrative.land_parcel',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#BDBDBD',
                    },
                ],
            },
            {
                'featureType': 'administrative.locality',
                'elementType': 'geometry.stroke',
                'stylers': [
                    {
                        'color': '#787878',
                    },
                ],
            },
            {
                'featureType': 'administrative.province',
                'elementType': 'geometry.stroke',
                'stylers': [
                    {
                        'color': '#787878',
                    },
                    {
                        'weight': 1.5,
                    },
                ],
            },
            {
                'featureType': 'poi',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#EEEEEE',
                    },
                ],
            },
            {
                'featureType': 'poi',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#787878',
                    },
                ],
            },
            {
                'featureType': 'poi',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#FFFFFF',
                    },
                ],
            },
            {
                'featureType': 'poi',
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {
                        'color': '#000000',
                    },
                ],
            },
            {
                'featureType': 'road',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#FFFFFF',
                    },
                ],
            },
            {
                'featureType': 'road',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#000000',
                    },
                ],
            },
            {
                'featureType': 'road',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#FFFFFF',
                    },
                ],
            },
            {
                'featureType': 'road',
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {
                        'color': '#000000',
                    },
                ],
            },
            {
                'featureType': 'transit.line',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#E5E5E5',
                    },
                ],
            },
            {
                'featureType': 'transit.line',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#212121',
                    },
                    {
                        'weight': 1,
                    },
                ],
            },
            {
                'featureType': 'transit.station',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#EEEEEE',
                    },
                ],
            },
            {
                'featureType': 'water',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#757575',
                    },
                ],
            },
            {
                'featureType': 'water',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#FFFFFF',
                    },
                ],
            },
            {
                'featureType': 'water',
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {
                        'color': '#000000',
                    },
                ],
            },
        ],
    });
    var avara = {
        lat: 47.406592, lng: 9.326539,
    };
    new google.maps.Marker({
        position: avara,
        map: map,
    });
};
